<template>
  <div class="Home__Container">
    <div class="Home__TextContainer">
      <div
        class="Home__TextBlock"
        v-if="table"
      >
        <div class="Home__TextTitle">
          <p class="Home__TextTitle_Text">
            CORAIL {{ trad(table.name) }}
          </p>
        </div>
        <div class="Home__TextParagraph">
          <p class="Home__TextParagraph_Text">
            {{ trad(table.description) }}
          </p>
        </div>
        <div
          class="Home__TextData"
          v-if="$store.getters.selectedLang === 'en-US'"
        >
          <div
            class="Home_DataRound"
            v-if="table.type==='round'"
          >
            <div class="Home_Data_TextRound">
              <span class="textregular"> {{ table.diameter.imperial }} </span><span class="textbold">Dia.</span>
            </div>
            <div class="Home_Data_TextRound">
              <span class="textbold">Ø</span><span class="textregular"> {{ table.diameter.metric }} cm</span>
            </div>
          </div>
          <div
            class="Home_Data"
            v-if="table.type==='rectangular'"
          >
            <div class="Home_Data_Text">
              <span class="textregular"> {{ table.length.imperial }}</span><span class="textbold">{{ $t('length') }}. x </span>
            </div>
            <div class="Home_Data_Text">
              <span class="textregular">{{ table.width.imperial }} </span><span class="textbold">{{ $t('depth') }}.</span>
            </div>
          </div>
          <div
            class="Home_Data"
            v-if="table.type==='rectangular'"
          >
            <div class="Home_Data_Text">
              <span class="textbold">{{ $t('length') }}.</span><span class="textregular"> {{ table.length.metric }} x </span>
            </div>
            <div class="Home_Data_Text">
              <span class="textbold">{{ $t('depth') }}.</span><span class="textregular">{{ table.width.metric }} cm</span>
            </div>
          </div>
        </div>
        <div
          class="Home__TextData"
          v-else
        >
          <div
            class="Home_DataRound"
            v-if="table.type==='round'"
          >
            <div class="Home_Data_TextRound">
              <span class="textbold">Ø</span><span class="textregular"> {{ table.diameter.metric }} cm</span>
            </div>
            <div class="Home_Data_TextRound">
              <span class="textregular"> {{ table.diameter.imperial }} </span><span class="textbold">Dia.</span>
            </div>
          </div>
          <div
            class="Home_Data"
            v-if="table.type==='rectangular'"
          >
            <div class="Home_Data_Text">
              <span class="textbold">{{ $t('length') }}.</span><span class="textregular"> {{ table.length.metric }} x </span>
            </div>
            <div class="Home_Data_Text">
              <span class="textbold">{{ $t('depth') }}.</span><span class="textregular">{{ table.width.metric }} cm</span>
            </div>
          </div>
          <div
            class="Home_Data"
            v-if="table.type==='rectangular'"
          >
            <div class="Home_Data_Text">
              <span class="textregular"> {{ table.length.imperial }}</span><span class="textbold">{{ $t('length') }}. x </span>
            </div>
            <div class="Home_Data_Text">
              <span class="textregular">{{ table.width.imperial }} </span><span class="textbold">{{ $t('depth') }}.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Home__ButtonContainer">
      <div
        class="Home__Button"
        @click="Customize()"
      >
        <p class="Home__Button_Text">
          {{ $t('home-customize') }}
        </p>
      </div>
    </div>
    <div class="Home__FooterContainer">
      <Carrousel :previewtop="previewTop" />
      <div
        class="Home__TextSwitch"
        @click="previewTop = !previewTop"
      >
        <SwitchPreview :previewtop="previewTop" />
      </div>
    </div>
    <div
      class="Home__Code"
      @click="OpenCodePage()"
    >
      <div class="Home__CodeIcon" />
    </div>
  </div>
</template>

<script>
import Carrousel from './components/Carrousel'
import SwitchPreview from './components/SwitchPreview'
import i18n from '@/mixins/i18n'
import { mapGetters } from 'vuex'

export default {
  mixins: [i18n],
  data () {
    return {
      previewTop: true
    }
  },
  components: {
    Carrousel,
    SwitchPreview
  },
  computed: {
    ...mapGetters(['table'])
  },
  methods: {
    Customize () {
      this.$store.dispatch('SetStep', 1)
      this.$store.dispatch('SetSliders', [0, 0, 0, 0])
      this.$store.dispatch('SetUVs', [this.table.defaultUV[0], this.table.defaultUV[1], this.table.defaultUV[2], this.table.defaultUV[3], this.table.defaultUV[4], this.table.defaultUV[5]])
      this.$store.dispatch('SetForces', [0, 0, 0])
    },
    OpenCodePage () {
      this.$store.dispatch('SetCode', true)
    }
  }
}
</script>

<style scoped>
.Home__Container {
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  pointer-events: none;
  flex-direction: column;
  pointer-events: none;
  overflow: hidden;
}

.Home__FooterContainer {
  position: relative;
  width: 65%;
  height: 165px;
  align-self: center;
}

.Home__Button {
  width: auto;
  background: black;
  border-radius: 20px;
  display: flex;
  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
  pointer-events: auto;
  justify-content: center;
}

.Home__Button_Text {
  padding-top: 0px;
  padding-left: 20px;
  padding-right: 20px;
  color: white;
  margin: auto;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 3px;
}

@media screen and (min-width: 1300px) {
  .Home__TextContainer {
    width: 62%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 8%;
  }
  .Home__TextBlock {
    align-self: flex-start;
    width: 50%;
    height: auto;
    display: flex;
    flex-direction: column;
    border-right: 2px solid rgba(200,200,200,0.5);
    padding-right: 1.5em;
  }

  .Home__TextTitle_Text{
    font-size: 1.7em;
    font-weight: 400;
  }

  .Home__TextParagraph {
    align-self: flex-end;
    width: 70%;
  }

  .Home__TextParagraph_Text{
    font-size: 1em;
    font-weight: 100;
    text-align: end;
    white-space: pre-line;
  }

  .textbold {
    font-size: 1em;
    font-weight: 300;
  }

  .textregular{
    font-size: 1em;
    font-weight: 100;
  }
  .Home__Code{
  position: absolute;
  right: 55px;
  top: 55px;
  width: 55px;
  height: 55px;
  background: white;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  pointer-events: auto;
   filter: drop-shadow(0 1mm 1mm rgb(0, 0, 0, 0.3));
}

.Home__ButtonContainer {
  width: 100%;
  height: 2em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 2em;
  z-index: 100;
}

.Home__TextSwitch {
  position: absolute;
  top: -4em;
  right: 0;
  pointer-events: auto;
}
}

@media screen and (max-width: 1300px) {
  .Home__TextContainer {
    width: 62%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 6%;
  }
  .Home__TextBlock {
    align-self: flex-start;
    width: 40%;
    height: auto;
    display: flex;
    flex-direction: column;
    border-right: 2px solid rgba(200,200,200,0.5);
    padding-right: 1.5em;
  }

  .Home__TextTitle_Text{
    font-size: 1.4em;
    font-weight: 400;
  }

  .Home__TextParagraph {
    align-self: flex-end;
    margin-bottom: 0em;
    width: 80%;
    margin-top: 0em;
  }

  .Home__TextParagraph_Text{
    font-size: 0.8em;
    font-weight: 100;
    text-align: end;
    white-space: pre-line;
  }

  .textbold {
    font-size: 0.8em;
    font-weight: 300;
  }

  .textregular{
    font-size: 0.8em;
    font-weight: 100;
  }
  .Home__Code{
  position: absolute;
  right: 55px;
  top: 30px;
  width: 42px;
  height: 42px;
  background: white;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  pointer-events: auto;
   filter: drop-shadow(0 1mm 1mm rgb(0, 0, 0, 0.3));
}

.Home__ButtonContainer {
  width: 100%;
  height: 2em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 0em;
  z-index: 100;
}

.Home__TextSwitch {
  position: absolute;
  top: -2em;
  right: 0;
  pointer-events: auto;
}
}

.Home__TextTitle {
  align-self: flex-end;
  text-align: right;
  margin-bottom: 0.5em;
}

.Home__TextData {
 align-self: flex-end;
 margin-top: 0.5em;
 display: flex;
 flex-direction: column;
}

.Home_Data{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 0.3em;
}

.Home_DataRound {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 0em;
}

.Home_Data {
}

.Home_Data_Text {
  align-self: flex-end;
  margin-left: 0.2em;
  font-size: 0.8em;
}

.Home_Data_TextRound {
  align-self: flex-end;
  margin-left: 0.2em;
  font-size: 0.8em;
  margin-top: 0.3em;
}

.Home__TextData_Text{
  margin-top: 1em;
  font-size: 18px;
  font-weight: 200;
}

.Home__CodeIcon{
  width: 45%;
  height: 45%;
  margin: auto;
  background: black;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  mask-image: url('../../assets/icons/code.svg');
}
</style>
